import { createRootRoute, Outlet } from "@tanstack/react-router";
import { ThemeProvider } from "@/contexts/theme-context";
import { NotificationProvider } from "@/contexts/notification-context";
import { ToastProvider } from "@/components/ui/toast";
import { RuntimeConfigBootstrap } from "@/components/runtime-config-bootstrap";
import { QueryProvider } from "@/components/query-provider";
import "../globals.css";

// Dev-only init script: applies localStorage/sessionStorage init from a
// querystring payload (used by the e2e harness). Inlined into index.html
// rather than rendered into a route component, so this hook here is just
// a no-op stub — see web-ui/index.html for the actual script.

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ThemeProvider>
      <RuntimeConfigBootstrap />
      <QueryProvider>
        <NotificationProvider>
          <ToastProvider>
            <Outlet />
          </ToastProvider>
        </NotificationProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
